export default "__VITE_ASSET__BPFe3XX8__"